/** @jsxRuntime classic */
/** @jsx jsx */
import { useRef, useContext } from "react";
import { useDay } from "@datepicker-react/hooks";
import { jsx } from "@emotion/core";
import DatepickerContext from "./datepickerContext";
import getColor from "../utils/getColor";
import { useSelector } from "react-redux";

function Day({ dayLabel, date }) {
  const dayRef = useRef(null);
  const {
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateSelect,
    onDateFocus,
    onDateHover
  } = useContext(DatepickerContext);
  const {
    isSelected,
    isSelectedStartOrEnd,
    isWithinHoverRange,
    disabledDate,
    onClick,
    onKeyDown,
    onMouseEnter,
    tabIndex
  } = useDay({
    date,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateFocus,
    onDateSelect,
    onDateHover,
    dayRef
  });

  if (!dayLabel) {
    return <div />;
  }

  const getColorFn = getColor(
    isSelected,
    isSelectedStartOrEnd,
    isWithinHoverRange,
    disabledDate
  );

  return (
    <button
      onClick={onClick}
      onKeyDown={onKeyDown}
      onMouseEnter={onMouseEnter}
      tabIndex={tabIndex}
      type="button"
      ref={dayRef}
      css={{
        padding: '8px',
        border: '0',
        borderRadius: '40pc',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '300',
        fontSize: '14px',
        lineHeight: 'normal',
        cursor: 'pointer',
        opacity: !isSelectedStartOrEnd ? 0.8 : 1,
        color: getColorFn({
          selectedFirstOrLastColor: "var(--theme-mode-color-white)",
          normalColor: "var(--theme-mode-color-white-reverse)",
          selectedColor: "var(--theme-mode-color-white)",
          rangeHoverColor: "var(--theme-mode-color-white)",
          disabledColor: "#808285"
        }),
        background: getColorFn({
          selectedFirstOrLastColor: "radial-gradient(47.12% 100.02% at 50% 100%, rgba(var(--theme-mode-rgb-white-reverse), 0.60) 0%, rgba(var(--theme-mode-rgb-white-reverse), 0.90) 100%), var(--accent-color)",
          normalColor: "transparent",
          selectedColor: "radial-gradient(47.12% 100.02% at 50% 100%, rgba(var(--theme-mode-rgb-white-reverse), 0.60) 0%, rgba(var(--theme-mode-rgb-white-reverse), 0.90) 100%), var(--accent-color)",
          rangeHoverColor: "#71c9ed",
          disabledColor: "#FFFFFF"
        }),
        '&:hover':{
          background: "var(--accent-color)",
          color: "var(--theme-mode-color-white-reverse)"
        }
      }}
    >
      {dayLabel.replace(/^[0]/, '')}
    </button>
  );
}

export default Day;
